import { templateSelectors } from '../../../store/modules/template';

import { TemplateMediaProps } from './types';

export const getTemplateMedia = ({
  template,
  currentFormats
}: TemplateMediaProps) => {
  const { defaultTarget, media } = template.meta;

  const currentFormatsNames = currentFormats.map(t => t.name);

  const currentTarget = Object.keys(media).reduce((acc, formatName) => {
    if (currentFormatsNames.includes(formatName)) {
      return formatName;
    }

    return acc;
  }, defaultTarget);

  const currentMedia = media[currentTarget];

  const { url: preview } = templateSelectors.selectSmallSize(
    currentMedia.thumb
  );
  const { url: videoUrl } = templateSelectors.selectSmallSize(
    currentMedia.video
  );

  return { preview, videoUrl };
};
